<h2>{{action}} Institution</h2>

<form [formGroup]="form" (ngSubmit)="submit()">

    <div class="column">
        <mat-form-field>
            <mat-label>Name</mat-label>
            <input matInput
                   formControlName="name"
                   required>
            <mat-error>{{fields.name.errors}}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Type*</mat-label>
            <mat-select formControlName="type">
                <mat-option value=""></mat-option>
                <mat-option *ngFor="let type of TYPES" [value]="type">{{type}}</mat-option>
            </mat-select>
            <mat-error>{{fields.type.errors}}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Street Address</mat-label>
            <input matInput
                   formControlName="street"
                   required>
            <mat-error>{{fields.street.errors}}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Street Address Line 2</mat-label>
            <input matInput
                   formControlName="street_2">
        </mat-form-field>

        <mat-form-field>
            <mat-label>City</mat-label>
            <input matInput
                   formControlName="city"
                   required>
            <mat-error>{{fields.city.errors}}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>State*</mat-label>
            <mat-select formControlName="state">
                <mat-option value=""></mat-option>
                <mat-option *ngFor="let state of US_STATES" [value]="state.code">{{state.name}}</mat-option>
            </mat-select>
            <mat-error>{{fields.state.errors}}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Zip</mat-label>
            <input matInput
                   formControlName="zip"
                   required>
            <mat-error>{{fields.zip.errors}}</mat-error>
        </mat-form-field>
    </div>

    <div class="column">
        <mat-form-field>
            <mat-label>Contact Name</mat-label>
            <input matInput
                   formControlName="contactName"
                   required>
            <mat-error>{{fields.contactName.errors}}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Contact Role</mat-label>
            <input matInput
                   formControlName="contactRole">
            <mat-error>{{fields.contactRole.errors}}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Contact Email</mat-label>
            <input matInput
                   formControlName="contactEmail"
                   required>
            <mat-error>{{fields.contactEmail.errors}}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Contact Phone</mat-label>
            <input matInput
                   formControlName="contactPhone">
            <mat-error>{{fields.contactPhone.errors}}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Notification Email</mat-label>
            <input matInput
                   formControlName="notificationEmail">
            <mat-hint>If different from Contact Email</mat-hint>
            <mat-error>{{fields.notificationEmail.errors}}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Promo Prefix</mat-label>
            <input matInput
                   formControlName="promoPrefix"
                   required>
            <mat-hint>At least 3 characters (letters or digits only)</mat-hint>
            <mat-error>{{fields.promoPrefix.errors}}</mat-error>
        </mat-form-field>
    </div>

    <div class="column">
        <mat-form-field floatLabel="always">
            <mat-label>Notes</mat-label>
            <textarea matInput
                   placeholder="Any additional info about this institution"
                   formControlName="notes"></textarea>
            <mat-error>{{fields.notes.errors}}</mat-error>
        </mat-form-field>

        <div class="button_row">
            <button mat-raised-button
                    color="primary"
                    [disabled]="!canSave()"
                    type="submit">Save</button>
            <button mat-raised-button
                    [disabled]="updating"
                    type="button"
                    (click)="cancel()">Cancel</button>
        </div>
        <div>
            <mat-spinner *ngIf="updating" [diameter]="30"></mat-spinner>
        </div>
    </div>
</form>
